var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomPattern2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 356,
    height: 636,
    viewBox: "0 0 356 636",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 298.059V378.097H56.3882L142.454 541.139L103.873 636H178.068L216.649 541.139L89.0339 298.059H0Z",
    fill: "#EE3124"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M206.261 379.58L356.617 0H431.999L250.778 459.618L206.261 379.58Z",
    fill: "#003A70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomPattern2);
export default __webpack_public_path__ + "static/media/bottom_pattern_2.b638faedd21d059c782c1c007ab7a2c8.svg";
export { ForwardRef as ReactComponent };